<template>
  <div ref="seccionContadorRef" class="seccion-editorial-container">
    
    <!-- 1. MOÑO SUPERIOR FULL-WIDTH (EDGE-TO-EDGE) -->
    <div ref="monioRef" class="monio-full-width-wrapper">
      <img 
        src="@/assets/monio.png" 
        alt="Moño Rojo" 
        class="monio-img"
      >
    </div>

    <!-- 2. LAYOUT PRINCIPAL DESACOPLADO -->
    <div class="contenido-editorial-wrapper">

      <!-- BLOQUE DE TEXTO E INFORMACIÓN (INDEPENDIENTE) -->
      <div class="info-columna">
        
        <!-- TITULO EDITORIAL -->
        <div ref="headerTextRef" class="header-text-block">
          <h2 class="the-details-title">Falta Muy Poco</h2>
          <div class="linea-decorativa-gold"></div>
        </div>

        <!-- FRASE POÉTICA -->
        <div ref="fraseRef" class="frase-container">
          <p class="frase-linea">¡CADA SEGUNDO MÁS CERCA</p>
          <p class="frase-linea">DE MI GRAN DÍA!</p>
        </div>

        <!-- TITULO CONTADOR -->
        <div ref="tituloContadorRef" class="titulo-contador">
          <span class="solo-text">Solo</span>
          <span class="faltan-text">FALTAN</span>
        </div>

        <!-- CONTADOR MINIMALISTA (SIN CUADROS) -->
        <div ref="gridNumerosRef" class="contador-limpio-grid">
          <div class="tiempo-item">
            <span class="numero">{{ dias }}</span>
            <span class="etiqueta">Días</span>
          </div>
          <div class="tiempo-item">
            <span class="numero">{{ horas }}</span>
            <span class="etiqueta">Horas</span>
          </div>
          <div class="tiempo-item">
            <span class="numero">{{ minutos }}</span>
            <span class="etiqueta">Minutos</span>
          </div>
          <div class="tiempo-item">
            <span class="numero">{{ segundos }}</span>
            <span class="etiqueta">Segundos</span>
          </div>
        </div>

      </div>

      <!-- MUÑECA ANCLADA AL BORDE IZQUIERDO Y AL FONDO -->
      <div ref="muniecaRef" class="munieca-container">
        
        <!-- ✦ CAPA DE POLVO MÁGICO / BLING BLING ULTRA TUPIDO -->
        <div class="polvo-magico-munieca" aria-hidden="true">
          <span class="polvo-m p1">★</span>
          <span class="polvo-m p2">✦</span>
          <span class="polvo-m p3">•</span>
          <span class="polvo-m p4">✧</span>
          <span class="polvo-m p5">★</span>
          <span class="polvo-m p6">✦</span>
          <span class="polvo-m p7">•</span>
          <span class="polvo-m p8">✧</span>
          <span class="polvo-m p9">★</span>
          <span class="polvo-m p10">✦</span>
          <span class="polvo-m p11">•</span>
          <span class="polvo-m p12">✧</span>
          <span class="polvo-m p13">★</span>
          <span class="polvo-m p14">✦</span>
          <span class="polvo-m p15">•</span>
          <span class="polvo-m p16">✧</span>
          <span class="polvo-m p17">★</span>
          <span class="polvo-m p18">✦</span>
          <span class="polvo-m p19">•</span>
          <span class="polvo-m p20">✧</span>
          <span class="polvo-m p21">★</span>
          <span class="polvo-m p22">✦</span>
          <span class="polvo-m p23">•</span>
          <span class="polvo-m p24">✧</span>
          <span class="polvo-m p25">★</span>
          <span class="polvo-m p26">✦</span>
          <span class="polvo-m p27">•</span>
          <span class="polvo-m p28">✧</span>
          <span class="polvo-m p29">★</span>
          <span class="polvo-m p30">✦</span>
          <span class="polvo-m p31">•</span>
          <span class="polvo-m p32">✧</span>
        </div>

        <img 
          src="@/assets/quincee.png" 
          alt="Quinceañera" 
          class="munieca-img"
        >
      </div>

    </div>

  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'ContadorEditorialLimpio',
  setup() {
    const seccionContadorRef = ref(null)
    const monioRef = ref(null)
    const muniecaRef = ref(null)
    const headerTextRef = ref(null)
    const fraseRef = ref(null)
    const tituloContadorRef = ref(null)
    const gridNumerosRef = ref(null)

    const dias = ref('00')
    const horas = ref('00')
    const minutos = ref('00')
    const segundos = ref('00')

    let timerId = null

    const iniciarCuentaAtras = () => {
      const fechaEvento = new Date('2026-11-13T20:00:00')
      
      const calcularTiempo = () => {
        const ahora = new Date()
        const dif = fechaEvento - ahora

        if (dif <= 0) {
          dias.value = horas.value = minutos.value = segundos.value = '00'
          if (timerId) clearInterval(timerId)
          return
        }

        dias.value = String(Math.floor(dif / (1000 * 60 * 60 * 24))).padStart(2, '0')
        horas.value = String(Math.floor((dif / (1000 * 60 * 60)) % 24)).padStart(2, '0')
        minutos.value = String(Math.floor((dif / (1000 * 60)) % 60)).padStart(2, '0')
        segundos.value = String(Math.floor((dif / 1000) % 60)).padStart(2, '0')
      }

      calcularTiempo()
      timerId = setInterval(calcularTiempo, 1000)
    }

    onMounted(() => {
      iniciarCuentaAtras()

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: seccionContadorRef.value,
          start: 'top 80%',
          toggleActions: 'play none none none'
        }
      })

      // 1. Moño superior desciende suavemente
      tl.from(monioRef.value, {
        opacity: 0,
        y: -25,
        duration: 1,
        ease: 'power2.out'
      })

      // 2. Bloque de título "Faltan Muy Poco"
      .from(headerTextRef.value, {
        opacity: 0,
        y: 20,
        duration: 0.8,
        ease: 'power2.out'
      }, '-=0.6')

      // 3. Frase poética
      .from(fraseRef.value, {
        opacity: 0,
        y: 15,
        duration: 0.7,
        ease: 'power2.out'
      }, '-=0.5')

      // 4. Título "Solo Faltan"
      .from(tituloContadorRef.value, {
        opacity: 0,
        scale: 0.95,
        duration: 0.6,
        ease: 'back.out(1.2)'
      }, '-=0.4')

      // 5. Números del contador
      .from(gridNumerosRef.value.children, {
        opacity: 0,
        y: 20,
        duration: 0.5,
        stagger: 0.08,
        ease: 'power2.out'
      }, '-=0.3')

      // 6. Muñeca emerge desde la izquierda
      .from(muniecaRef.value, {
        opacity: 0,
        x: -40,
        duration: 1.1,
        ease: 'power3.out'
      }, '-=0.8')
    })

    onUnmounted(() => {
      if (timerId) clearInterval(timerId)
    })

    return {
      seccionContadorRef,
      monioRef,
      muniecaRef,
      headerTextRef,
      fraseRef,
      tituloContadorRef,
      gridNumerosRef,
      dias,
      horas,
      minutos,
      segundos
    }
  }
}
</script>

<style scoped>
/* ==========================================
   1. CONTENEDOR GENERAL EDGE-TO-EDGE
   ========================================== */
.seccion-editorial-container {
  position: relative;
  width: 100vw;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  min-height: 100vh;
  min-height: 100dvh;
  background-color: #ffffff;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  margin-top: -80px;
  margin-bottom: 130px;
  flex-direction: column;
}

/* ==========================================
   2. MOÑO SUPERIOR SIN MARGENES
   ========================================== */
.monio-full-width-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow: hidden;
  z-index: 5;
}

.monio-img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}

/* ==========================================
   3. ESTRUCTURA EDITORIAL FLUIDA
   ========================================== */
.contenido-editorial-wrapper {
  position: relative;
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
  padding-top: 1.5vh;
  box-sizing: border-box;
}

/* COLUMNA DERECHA INDEPENDIENTE */
.info-columna {
  position: relative;
  z-index: 3;
  width: 60vw;
  margin-top: -4vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding-right: 6vw;
  box-sizing: border-box;
}

/* MUÑECA ABSOLUTA CON DESPLAZAMIENTO RELATIVO Y POLVO MÁGICO */
.munieca-container {
  position: absolute;
  bottom: 0;
  top: -5vh;
  left: -84vw;
  height: 63vh;
  max-height: 520px;
  z-index: 1;
  pointer-events: none;
}

.munieca-img {
  height: 100%;
  width: auto;
  display: block;
  object-fit: contain;
  filter: drop-shadow(4px 6px 12px rgba(0, 0, 0, 0.08));
  position: relative;
  z-index: 1;
}

/* ✦ CAPA DE POLVO MÁGICO BLING BLING SOBRE LA MUÑECA */
.polvo-magico-munieca {
  position: absolute;
  inset: -15px;
  pointer-events: none;
  z-index: 2;
  overflow: hidden;
}

.polvo-m {
  position: absolute;
  color: #FFFFFF;
  text-shadow: 
    0 0 3px #FFFFFF,
    0 0 6px #FFFFFF,
    0 0 10px #e6a7c3,
    0 0 14px #FFFFFF;
  animation: destelloMuñecaBling 1.8s infinite ease-in-out;
  will-change: transform, opacity;
}

/* Tamaños mini ultradensados */
.p1, .p5, .p9, .p13, .p17, .p21, .p25, .p29 { font-size: 0.45rem; }
.p2, .p6, .p10, .p14, .p18, .p22, .p26, .p30 { font-size: 0.6rem; }
.p3, .p7, .p11, .p15, .p19, .p23, .p27, .p31 { font-size: 0.3rem; }
.p4, .p8, .p12, .p16, .p20, .p24, .p28, .p32 { font-size: 0.5rem; }

/* Distribución tupida en toda la silueta */
.p1  { top: 5%;  left: 25%; animation-delay: 0.1s; }
.p2  { top: 8%;  left: 55%; animation-delay: 0.5s; }
.p3  { top: 12%; left: 40%; animation-delay: 0.9s; }
.p4  { top: 15%; left: 70%; animation-delay: 0.3s; }
.p5  { top: 20%; left: 18%; animation-delay: 1.2s; }
.p6  { top: 22%; left: 50%; animation-delay: 0.7s; }
.p7  { top: 26%; left: 32%; animation-delay: 0.2s; }
.p8  { top: 28%; left: 78%; animation-delay: 1.4s; }
.p9  { top: 32%; left: 62%; animation-delay: 0.6s; }
.p10 { top: 35%; left: 22%; animation-delay: 1.0s; }
.p11 { top: 39%; left: 45%; animation-delay: 0.4s; }
.p12 { top: 42%; left: 82%; animation-delay: 1.5s; }
.p13 { top: 45%; left: 15%; animation-delay: 0.8s; }
.p14 { top: 48%; left: 58%; animation-delay: 0.1s; }
.p15 { top: 52%; left: 38%; animation-delay: 1.3s; }
.p16 { top: 55%; left: 75%; animation-delay: 0.9s; }
.p17 { top: 58%; left: 28%; animation-delay: 0.3s; }
.p18 { top: 62%; left: 65%; animation-delay: 1.1s; }
.p19 { top: 65%; left: 48%; animation-delay: 0.5s; }
.p20 { top: 68%; left: 85%; animation-delay: 1.6s; }
.p21 { top: 72%; left: 20%; animation-delay: 0.7s; }
.p22 { top: 75%; left: 52%; animation-delay: 0.2s; }
.p23 { top: 78%; left: 35%; animation-delay: 1.4s; }
.p24 { top: 82%; left: 68%; animation-delay: 1.0s; }
.p25 { top: 85%; left: 12%; animation-delay: 0.4s; }
.p26 { top: 88%; left: 42%; animation-delay: 0.8s; }
.p27 { top: 90%; left: 78%; animation-delay: 1.3s; }
.p28 { top: 92%; left: 25%; animation-delay: 0.6s; }
.p29 { top: 94%; left: 60%; animation-delay: 0.1s; }
.p30 { top: 96%; left: 34%; animation-delay: 1.1s; }
.p31 { top: 97%; left: 82%; animation-delay: 0.5s; }
.p32 { top: 98%; left: 50%; animation-delay: 1.5s; }

@keyframes destelloMuñecaBling {
  0%, 100% {
    opacity: 0.1;
    transform: scale(0.5) translateY(0);
  }
  50% {
    opacity: 1;
    transform: scale(1.4) translateY(-3px);
  }
}

/* ==========================================
   4. TIPOGRAFÍAS Y ESTILOS CON CLAMP
   ========================================== */
.header-text-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1.2vh;
}

.the-details-title {
  font-family: 'ludovica', serif;
  font-size: clamp(1.8rem, 8vw, 2.8rem);
  color: #9b9a99;
  font-weight: 400;
  margin: 0;
  line-height: 1.1;
  white-space: nowrap;
}

.linea-decorativa-gold {
  width: clamp(25px, 8vw, 40px);
  height: 1px;
  background: #B28F60;
  margin-top: 0.4vh;
  opacity: 0.5;
}

.frase-container {
  margin-bottom: 1.4vh;
}

.frase-linea {
  font-family: 'Playfair Display', serif;
  font-size: clamp(0.6rem, 2.6vw, 0.75rem);
  color: #9b9a99;
  margin: 0;
  line-height: 1.4;
  font-weight: 600;
  letter-spacing: 0.1em;
}

.titulo-contador {
  margin-bottom: 1.2vh;
}

.solo-text {
  font-family: 'ludovica', serif;
  font-size: clamp(1.4rem, 6vw, 2rem);
  color: #9b9a99;
  display: block;
  line-height: 1;
}

.faltan-text {
  font-family: 'Playfair Display', serif;
  font-size: clamp(0.85rem, 3.8vw, 1.1rem);
  color: #e6a7c3;
  font-weight: 700;
  letter-spacing: 0.15em;
  display: block;
  margin-top: -0.2vh;
}

/* ==========================================
   5. CONTENEDOR CONTADOR
   ========================================== */
.contador-limpio-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 4vw;
  row-gap: 1.2vh;
  width: 100%;
  max-width: 45vw;
}

.tiempo-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: transparent;
  border: none;
  box-shadow: none;
}

.numero {
  font-family: 'Playfair Display', serif;
  font-size: clamp(1.5rem, 7vw, 2.2rem);
  font-weight: 600;
  color: #e6a7c3;
  line-height: 1;
}

.etiqueta {
  font-family: 'Playfair Display', serif;
  font-size: clamp(0.55rem, 2.3vw, 0.7rem);
  color: #9b9a99;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin-top: 0.4vh;
  font-weight: 500;
}
</style>